import { useTranslation } from "react-i18next";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../../components/ui/alert-dialog";

export default function CloseAlert({ open, setOpen, message }) {
  const { t } = useTranslation();
  const lines = message?.split("\n");
  return (
    <AlertDialog open={open} onOpenChange={(isOpen) => setOpen(isOpen)}>
      <AlertDialogContent className="p-0 rounded-lg sm:rounded-[20px] overflow-y-auto max-h-[calc(100vh-6rem)]">
        <div className="px-16 pt-5 pb-4 bg-green">
          <p className="text-green-900 text-xl sm:text-2xl font-bold whitespace-nowrap text-center">
            {t("alert")}
          </p>
        </div>
        <AlertDialogHeader className="px-4 py-3 sm:py-6 space-y-1.5">
          {lines.map((line, index) => (
            <AlertDialogTitle
              className="text-center max-sm:text-base"
              key={index}
            >
              {line}
            </AlertDialogTitle>
          ))}
        </AlertDialogHeader>
        <AlertDialogFooter>
          {/* footer */}
          <div className="w-full p-5 flex items-center justify-center border-t">
            <AlertDialogAction className="h-auto px-3 sm:px-6 py-2 sm:py-3 text-sm sm:text-base font-bold bg-red border border-red rounded-full text-white hover:opacity-85 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-red transition-ease">
              {t("close.button")}
            </AlertDialogAction>
          </div>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
